import React from "react";

import Label from "components/InputsField/Label";
import Input from "components/common/Input";

import styles from "./styles.module.scss";

const Messengers = ({
    label,
    messengersList,
    activeMessengersList,
    onMessengerClick,
    onMessengerChange,
}) => (
    <div>
        {label && <Label label={label} />}
        <ul className={styles.messengersList}>
            {messengersList &&
                messengersList.map((el, index) => (
                    <li
                        key={index}
                        className={
                            styles.messengerItem +
                            ` ${el.value}__logo
                        ${
                            activeMessengersList.filter((item) => el.id === item.id).length
                                ? ""
                                : "non-active"
                        }`
                        }
                        onClick={() => onMessengerClick(el)}
                    ></li>
                ))}
        </ul>
        {activeMessengersList && activeMessengersList.length > 0 && (
            <div className={styles.inputs}>
                {activeMessengersList.map((el, index) => (
                    <div className={styles.inputWrapper} key={index}>
                        <Label label={el.value} name={`messengers.${el.value}`} />
                        <Input
                            value={el.messenger}
                            onChange={onMessengerChange(el)}
                            maxLength="32"
                            minLength="3"
                            type="text"
                            placeholder={el.value}
                            id={`messengers.${el.value}`}
                            key={el.value + "emp"}
                        />
                    </div>
                ))}
            </div>
        )}
    </div>
);

export default Messengers;
